export const LOAD_ALL_QUOTES = 'LOAD_ALL_QUOTES';
export const LOAD_ALL_QUOTES_FAILED = 'LOAD_ALL_QUOTES_FAILED';
export const LOAD_ALL_QUOTES_CLIENT = 'LOAD_ALL_QUOTES_CLIENT';
export const SET_QUOTE_STATUS_BY_QUOTE_CLIENT_ID = 'SET_QUOTE_STATUS_BY_QUOTE_CLIENT_ID';
export const LOAD_QUOTE_BY_ID = 'LOAD_QUOTE_BY_ID';
export const UPDATE_TOKEN_QUOTE_BY_USER_EMAIL_AND_PASSWORD = 'UPDATE_TOKEN_QUOTE_BY_USER_EMAIL_AND_PASSWORD';
export const ADD_QUOTE = 'ADD_QUOTE';
export const UPDATE_QUOTE = 'UPDATE_QUOTE';
export const REMOVE_QUOTE_BY_ID = 'REMOVE_QUOTE_BY_ID';
export const ARCHIVE_QUOTE_BY_ID = 'ARCHIVE_QUOTE_BY_ID';
export const CLEAR_CURRENT_QUOTE = 'CLEAR_CURRENT_QUOTE';
export const GET_HTML_PRE_VIEW_QUOTE = 'GET_HTML_PRE_VIEW_QUOTE';
export const GET_HISTORY_QUOTE = 'GET_HISTORY_QUOTE';

export function addQuote(data) {
  return {
    type: ADD_QUOTE,
    payload: data,
  }
}

export function updateQuote(data) {
  return {
    type: UPDATE_QUOTE,
    payload: data,
  }
}

export function loadAllQuotes(data) {
  return {
    type: LOAD_ALL_QUOTES,
    payload: data,
  }
}

export function loadAllQuotesFailed(data) {
  return {
    type: LOAD_ALL_QUOTES_FAILED,
    payload: data,
  }
}

export function loadAllQuotesClient(data) {
  return {
    type: LOAD_ALL_QUOTES_CLIENT,
    payload: data,
  }
}

export function setQuoteStatusByQuoteClientId(data) {
  return {
    type: SET_QUOTE_STATUS_BY_QUOTE_CLIENT_ID,
    payload: data,
  }
}

export function loadQuoteById(data) {
  return {
    type: LOAD_QUOTE_BY_ID,
    payload: data,
  }
}

export function updateTokenQuoteByUserEmailAndPassword(data) {
  return {
    type: UPDATE_TOKEN_QUOTE_BY_USER_EMAIL_AND_PASSWORD,
    payload: data,
  }
}

export function removeQuoteById(data) {
  return {
    type: REMOVE_QUOTE_BY_ID,
    payload: data,
  }
}

export function clearCurrentQuote() {
  return {
    type: CLEAR_CURRENT_QUOTE,
  }
}

export function getPreViewHtmlQuote(data) {
  return {
    type: GET_HTML_PRE_VIEW_QUOTE,
    payload: data,
  }
}

export function archiveQuote(data) {
  return {
    type: ARCHIVE_QUOTE_BY_ID,
    payload: data,
  }
}

export function actionGetHistoryUpdated(data) {
  return {
    type: GET_HISTORY_QUOTE,
    payload: data,
  }
}



// WEBPACK FOOTER //
// ./src/actions/quotes/index.js